import classNames from 'classnames';
import { defaultTo, omit } from 'lodash-es';
import type { ButtonProps } from './button';
import { Button } from './button';
import type { IconComponent } from './types';

export type IconButtonProps = Omit<ButtonProps, 'children'> & {
  label: string;
  icon: IconComponent;
  iconOnly?: boolean;
};

export const IconButton = (props: IconButtonProps) => (
  <Button tooltip={defaultTo(props.tooltip, props.iconOnly ? props.label : undefined)} {...omit(props, 'label', 'iconOnly')}>
    <span className="flex items-center justify-center flex-nowrap">
      <props.icon className={classNames({ 'mr-2': !props.iconOnly })} />
      <span className={classNames('whitespace-nowrap', { 'sr-only': props.iconOnly })}>{props.label}</span>
    </span>
  </Button>
);

export default IconButton;
